<template functional>
  <div
    v-if="props.socialMedia.length > 0"
    :ref="data.ref"
    :class="[data.class, data.staticClass]"
    :style="[data.style, data.staticStyle]"
    v-bind="data.attrs"
    class="clearfix md:px-x-gutter-sm"
  >
    <cta
      v-for="post in props.socialMedia"
      :key="post._key"
      :tag="post.url ? 'recess-link' : 'div'"
      :href="post.url"
      frame
      class="post"
    >
      <figure>
        <sanity-media class="flex" v-bind="post.media" />
        <figcaption v-if="post.title">{{ title }}</figcaption>
      </figure>
    </cta>
  </div>
</template>

<script>
export default {
  name: 'SocialMedia',

  functional: true,

  props: {
    title: {
      default: null,
      type: String
    },
    socialMedia: {
      default: () => [],
      type: Array
    }
  }
}
</script>

<style scoped>
.post {
  --post-gutter: var(--x-gutter);
  margin-bottom: var(--post-gutter);
}

.post:nth-child(1) {
  float: left;
  margin-right: var(--post-gutter);
  width: 40%;
}

.post:nth-child(2) {
  float: right;
  margin-top: 2em;
  width: 40%;
}

.post:nth-child(3) {
  float: left;
  margin-left: 25%;
  width: 50%;
}

@screen sm {
  .post:nth-child(1) {
    width: 25%;
  }

  .post:nth-child(2) {
    width: 40%;
  }

  .post:nth-child(3) {
    float: right;
    margin-left: 0;
    margin-right: var(--post-gutter);
    width: 33.3%;
  }
}

@screen lg {
  .post {
    --post-gutter: var(--x-gutter-sm);
  }
}
</style>
